import React from 'react';

import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import { ListRendererType } from 'components/Grid/renderers/GridListRenderer/types';
import GridUserRenderer from 'components/Grid/renderers/GridUserRenderer';
import { PickerItemKind, PickerValue } from 'components/SharedFormComponents/UserAndGroupPicker';

import { toPickerValues } from 'containers/ScheduleDetails/utils/performers';

import { ScheduleDetailsResponse } from 'utils/api/modules/schedules/schedules.types';

import { GroupAvatar, GroupItem, GroupName } from './styles';

export const assignedToItemRenderer: ListRendererType = ({ value }) => {
  const item = value?.value as PickerValue | undefined;
  if (!item) return null;

  if (item.kind === PickerItemKind.Group) {
    return (
      <GroupItem aria-label={item.name} data-testid="schedule-assignee-cell-group">
        <GroupAvatar>
          <GroupsOutlinedIcon />
        </GroupAvatar>
        <GroupName>{item.name}</GroupName>
      </GroupItem>
    );
  }

  return <GridUserRenderer value={item} />;
};

// Groups first, then named users, as the picker shows them.
export const assignedToValueGetter = (_: unknown, row: ScheduleDetailsResponse): PickerValue[] =>
  toPickerValues(row.assignedTo, row.assignedGroups);

export const assignedToFormatter = (value: PickerValue[] | undefined): string =>
  (value ?? []).map((item) => item.name ?? '').join(', ');
